import { render, staticRenderFns } from "./GravarContatoRealizadoDialog.vue?vue&type=template&id=5875ef95&"
import script from "./GravarContatoRealizadoDialog.vue?vue&type=script&lang=js&"
export * from "./GravarContatoRealizadoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GravarContatoRealizadoDialog.vue"
export default component.exports